import {Environment} from './environment.interface';

export const defaultEnv: Environment = {
  env: 'local',
  language: 'pl',
  serviceWorker: 'service.worker.local.js'
};
